export default defineNuxtPlugin(() => {
  const route = useRoute();
  const config = useRuntimeConfig();

  // Pages that should not have canonical URLs (they should have noindex instead)
  const noIndexPages = ['/checkout', '/konto', '/payment-processing', '/feedback', '/payment-error'];

  // Check if current page should be indexed
  const shouldIndex = !noIndexPages.some((noIndexPath) => route.path.startsWith(noIndexPath));
  if (shouldIndex && config.public.is_production && !route.query.nuxt_reload_attempt) {
    const normalizedPath = route.path.replace(/\/+$/, '') || '/';
    const canonicalUrl = `${config.public.app_url}${normalizedPath}`;

    useHead({
      meta: [{ vmid: 'robots', name: 'robots', content: 'index, follow' }],
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: canonicalUrl
        }
      ]
    });
  } else {
    useHead({
      meta: [{ vmid: 'robots', name: 'robots', content: 'noindex, nofollow' }]
    });
  }
});
